/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2024, Zumper
 * @description  TourButtonContainer for ListingCard
 */

import { hocCompose } from '@zcode/react-utils'
import { withRouter } from '@zcode/router-utils'
import { connect } from 'react-redux'
import { mapStateToProps, memoMapDispatchToProps } from './TourButtonContainer'
import { TourButtonListCard } from './TourButtonListCard'

export const TourButtonListCardContainer = hocCompose(
  withRouter,
  connect(mapStateToProps, memoMapDispatchToProps),
  TourButtonListCard
)
